import Helper from "./helper";

export default class AppSettings {
  static apiUrl = "https://backoffice-test-informeprensa.aysa.com.ar";

  
  static defaultLocale = "es-AR";
  static loadingImageId = "c4cc4736-d890-4297-8dec-59d62abf2b24";
  static defaultTipoInforme = "13ed88f1-3da2-442a-b290-85bc28e2967f";
  static apiUrlAssets = this.apiUrl + "/assets/";
  static apiUrlItems = this.apiUrl + "/items/";
  static apiUrlTipoInforme =
    this.apiUrlItems +
    "tipo_informe?fields=tipo_informe_id,nombre,orden&sort=orden";
  static apiUrlInforme = this.apiUrlItems + "informes";
  static apiUrlNoticias = this.apiUrlItems + "noticias/";
  static apiUrlInformeLatestNews =
    this.apiUrlInforme +
    "?fields=noticias.orden,noticias.noticias_noticia_id.tema_noticia_id.nombre,noticias.noticias_noticia_id.titulo,noticias.noticias_noticia_id.fuente,noticias.noticias_noticia_id.copete,noticias.noticias_noticia_id.nota_resaltada,noticias.noticias_noticia_id.fecha,noticias.noticias_noticia_id.imagen_principal,noticias.noticias_noticia_id.media_url,noticias.noticias_noticia_id.noticia_id&sort=-fecha&limit=1";
  static apiUrlInformeLatestFecha = this.apiUrlInforme +
    "?fields=fecha&sort=-fecha&limit=1"
  static apiUrlInformeLatestTapas =`${this.apiUrlInforme}?fields=tapas.tapa,tapas.orden&filter[tipo_informe_id][_eq]=${this.defaultTipoInforme}&sort=-fecha&limit=1`
     
    
  static apiUrlNewsDetail =
    this.apiUrlNoticias +
    "?fields=noticia_id,fuente,fecha,columnista,titulo,copete,nota,nota_resaltada,imagen_principal,tema_noticia_id.nombre,media_url&filter[noticia_id][_eq]=";
  static noDataMessage = "No se encontraron items para la query realizada";
  static pages = { home: 0, news: 1 };
  static defaultPage = this.pages.home;
  static swiper = {
    desktop: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 0 },
    smalldesktop: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 0 },
    tablet: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 0 },
    mobile: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 0 },
    small: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0 },
    
    loop: true,
    loopFillGroupWithBlank: false,
    mobileWidth: 700,
  };
}
